export const PATHS = {
  uploadImage: `/image-upload`,
  uploadFile: `/file-upload`,
};
